import { Icon } from "@iconify/react/dist/iconify.js";

const DangerZone = ({ 
    currentOrgId, 
    organizations, 
    onDeleteCustomer 
}) => {
    // Only show for non-Helios organizations
    if (!currentOrgId || organizations.find(org => org.id === currentOrgId)?.name === 'helios') {
        return null;
    }

    return (
        <div className="w-full p-3 sm:p-4 bg-red-900 bg-opacity-10 rounded-md sm:rounded-lg">
            <div className="flex flex-col gap-3 sm:gap-4 lg:flex-row lg:items-center lg:justify-between 2xl:flex-row 2xl:items-center 2xl:justify-between">
                {/* Info section */}
                <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 flex-1 min-w-0">
                    <div className="flex flex-row gap-1 items-center">
                        <Icon icon="mdi:alert-circle" className="text-error text-2xl sm:text-3xl flex-shrink-0" />
                        <h3 className="text-lg sm:text-xl font-bold text-error">Danger Zone</h3>
                    </div>
                    <div className="min-w-0 flex-1">
                        <p className="text-xs sm:text-sm text-error leading-relaxed">
                            Permanently delete this customer and all associated data
                        </p>
                    </div>
                </div>

                {/* Action button */}
                <div className="flex-shrink-0 w-full sm:w-auto">
                    <button
                        onClick={() => {
                            const org = organizations.find(o => o.id === currentOrgId);
                            if (org) onDeleteCustomer(org);
                        }}
                        className="w-full sm:w-auto px-4 py-2 sm:px-6 sm:py-3 bg-red-600 font-semibold rounded-md sm:rounded-lg transition-colors duration-200 flex items-center justify-center gap-2 shadow-lg text-sm sm:text-base text-white"
                    >
                        <Icon icon="mdi:delete" className="text-xl sm:text-2xl" />
                        <span>Delete Customer</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DangerZone;
